import { ContentMediaType } from 'src/home_page/components/ContentPop/ContentPop'
import { BentoContentExpandType } from 'src/marketing/components/BentoGrid/BentoCard'
import { CardTypeImageDiffData } from 'src/marketing/mockData/CardTypeImageDiffData'

const cTcContentStream: ContentMediaType[] = [
  {
    content: {
      type: 'content',
      title: 'Customize every detail, cover to cover!',
      description:
        'Whether you are customizing a card for an invitation, branding for your business, or just to make something aesthetically pleasing to your recipient - we have you covered!',
    },
    width: '100%',
    height: 'auto',
  },
  {
    content: {
      type: 'content',
      title: '',
      description:
        'Our system allows you to completely take over the creative control and make your card uniquely yours. ',
    },
    width: '100%',
    height: 'auto',
  },
]
export const coverToCoverExpandData: BentoContentExpandType = {
  bannerImages: [
    'https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/popups/Cover-to-cover-main-image.png',
  ],
  contentStream: cTcContentStream,
  type: 'content',
  imageDiff: CardTypeImageDiffData[0],
}
